import { useTranslation } from "react-i18next";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import React from "react";
import MoveProductStock from "../../Components/Features/Inventory/ProductsStock/MoveProductStock";

export function MoveProductStockPage() {
  const { t } = useTranslation();

  return (
    <AppLayout>
      <PageLayout title={t("move_product_stock")}>
        <div className="h-fit max-w-1/2  bg-white rounded-xl shadow-accent-foreground shadow-2xl p-4">
          <MoveProductStock />
        </div>
      </PageLayout>
    </AppLayout>
  );
}
